import axios from "axios";

// Creates axios instance used for all API requests
const baseUrl = "https://api.annieinc.com/api";

const axiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

// Add JWT token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");

    if (token) {
      config.headers.Authorization = `JWT ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepts all axios instance requests and attempts to refresh token if it expired
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;

    if (originalRequest) {
      console.log(originalRequest.url);
    }

    // Prevent infinite loops
    if (
      error.response &&
      error.response.status === 401 &&
      originalRequest.url === "/token/refresh/"
    ) {
      window.location.href = "/login/";
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      delete axiosInstance.defaults.headers.Authorization;

      return Promise.reject(error);
    }

    if (
      error.response &&
      error.response.data &&
      error.response.data.code === "token_not_valid" &&
      error.response.status === 401
    ) {
      const refreshToken = localStorage.getItem("refresh_token");

      if (refreshToken) {
        const tokenParts = JSON.parse(
          atob(refreshToken.split(".")[1])
        );

        const now = Math.ceil(Date.now() / 1000);

        if (tokenParts.exp > now) {
          return axiosInstance
            .post("/token/refresh/", {
              refresh: refreshToken,
            })
            .then((response) => {
              localStorage.setItem(
                "access_token",
                response.data.access
              );

              localStorage.setItem(
                "refresh_token",
                response.data.refresh
              );

              axiosInstance.defaults.headers.Authorization =
                "JWT " + response.data.access;

              originalRequest.headers.Authorization =
                "JWT " + response.data.access;

              return axiosInstance(originalRequest);
            })
            .catch((err) => {
              console.log(err);

              localStorage.removeItem("access_token");
              localStorage.removeItem("refresh_token");

              window.location.href = "/login/";

              return Promise.reject(err);
            });
        } else {
          console.log(
            "Refresh token expired",
            tokenParts.exp,
            now
          );

          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");

          window.location.href = "/login/";
        }
      } else {
        console.log("Refresh token not available.");

        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");

        window.location.href = "/login/";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;